import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { NavigationService } from 'libs/portal/src/services/navigation/navigation.service';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { CardTableAction, CardTableOptions } from 'libs/portal/src/modules/tools/card-table/models';
import { FilterItem, FilterOptions } from 'libs/portal/src/modules/tools/filters/models';
import { CardTableHeader } from '../card-table/models/card-table-header.model';
import { LocationRadiusModalComponent } from '../../keepalive/components/location-radius-modal/location-radius-modal/location-radius-modal.component';
import { MatDialog } from '@angular/material/dialog';

export interface RingFenceLog {
  deviceNum: string;
  terminalid: string;
  radius: string;
  color: string;
  timestamp: string;
  lat: number;
  lng: number;
  user?: string;
}

@Component({
  selector: 'tools-device-ring-fence-log',
  templateUrl: './device-ring-fence-log.component.html',
  styleUrls: ['./device-ring-fence-log.component.scss'],
})
export class DeviceRingFenceLogComponent implements OnInit {
  @ViewChild('sticky') sticky: TemplateRef<any>;
  @Input() ringFenceData: any[];
  @Input() latestRingFenceValue: number;
  isLoaded = true;
  color = '#08074B';

  ScreenSize = ScreenSize;

  data: RingFenceLog[] = [];

  options: CardTableOptions = {
    titleProperty: 'terminalid',
    subTitleProperty: 'radius',
    contentProperty: 'user',
    indicatorColorProperty: 'color',
    selectedProperty: 'selected',
    isSelectable: false,
    flexCardLayout: false,
    propertyRowExclusions: ['color', 'selected', 'deviceNum', 'radius'],
    stylePropertyPrefix: 'ring-fence',
    clickableFlexCard: false,
    textSize: 'regular',
  };

  headers: CardTableHeader[] = [
    {
      ID: 'terminalid',
      Text: 'Terminal ID',
      Width: 12,
    },
    {
      ID: 'cellid',
      Text: 'Cell ID',
      Width: 10,
    },
    {
      ID: 'radius',
      Text: 'Radius',
      Width: 8,
    },
    {
      ID: 'lac',
      Text: 'LAC',
      Width: 8,
    },
    {
      ID: 'lat',
      Text: 'Lat',
      Width: 10,
    },
    {
      ID: 'lng',
      Text: 'Lng',
      Width: 10,
    },
    {
      ID: 'timestamp',
      Text: 'Timestamp',
      Width: 22,
    },
    {
      ID: 'user',
      Text: 'Set By',
      Width: 20,
    },
  ];

  rowActions: CardTableAction[] = [
    {
      title: 'View Ringfence Location',
      iconSrc: 'assets/icon/map.svg',
      color: 'primary',
      showIcon: true,
    },
  ];

  unknownLocationRowActions: CardTableAction[] = [
    {
      title: 'View Ringfence Location',
      iconSrc: 'assets/icon/map.svg',
      color: 'primary',
      showIcon: true,
      display: false,
    },
  ];

  filterOptions: FilterOptions = {
    showSearch: true,
    searchPlaceholder: 'Search for logs',
    showClearChip: true,
    enableChipsSortToggle: true,
    enableSearchFilterToggle: true,
  };

  filterChips: FilterItem[] = [
    {
      title: 'Status',
      value: 'status',
    },
    {
      title: 'Bundle',
      value: 'bundle',
    },
    {
      title: 'Location',
      value: 'location',
    },
    {
      title: 'Log type',
      value: 'logType',
    },
  ];
  constructor(private navigationService: NavigationService, private layoutService: LayoutService, private tools: ToolsService, private dialog: MatDialog) {}

  ngAfterViewInit(): void {
    this.layoutService.addStickyHeaderForRoute(this.navigationService.GetCurrentRoute(), this.sticky);
  }

  loadMoreData($event: any) {
    setTimeout(() => {
      $event.target.complete();

      // lets add some more data to the array
      // this.scrollToMoreData();

      // App logic to determine if all data is loaded
      // and disable the infinite scroll
      if (this.data.length > 4) {
        $event.target.disabled = true;
      }
    }, 500);
  }

  // Not Used
  // getPagedLogs() {}

  //Not Used
  // refreshData($event: any) {}

  //Not Used
  // scrollToMoreData() {}

  onAction($event: any) {
    if ($event.title == 'View Ringfence Location') {
      console.log($event);
      this.openAlertLocationModal($event);
    }
  }

  //Not Used
  // rowSelected($event: any): void {}

  ngOnInit() {
    if (this.ringFenceData != null) {
      this.ringFenceData.map((item) => {
        const log = {
          terminalid: item.Device.TerminalID,
          cellid: item.Tower != null ? item.Tower.CellID : 'N/A',
          deviceNum: item.Device.Imei,
          radius: item.Radius,
          displayRadius: `${item.Radius / 1000} Km`,
          lac: item.Tower != null ? item.Tower.LAC : 'N/A',
          color: this.color,
          lat: item.Center.lat,
          lng: item.Center.lng,
          timestamp: 'Updated: ' + this.tools.FormatDateTimeFromDate(this.tools.ParseAPIDate(item.Timestamp)),
          user: item.User ? item.User : '',
        };
        // if (item.User != null) {
        //   log["user"] = item.User;
        // }
        this.data.push(log);
      });
      // console.log(this.data);
    }
  }

  //ALL BELOW UNUSED
  // handleClick() {}

  // searchSubmit(value: string): void {}

  // searchValueChanged(value: string): void {}

  // filterToggled(chip: FilterItem): void {}

  // filtersCleared(): void {}

  // searchFilterToggled(): void {}

  // chipsSortToggled(): void {}

  // chipsMinimizeToggled(): void {}

  async openAlertLocationModal(event) {
    const device = event.row;
    console.log(device);
    this.dialog.open(LocationRadiusModalComponent, {
      data: {
        currentRingFenceValue: device.radius / 1000,
        deviceIds: [device.terminalid],
        accepted: true,
        device: {
          // imei: device.imei,
          terminalid: device.terminalid,
          location: {
            lat: device.lat,
            lng: device.lng,
          },
          data: device.data,
        },
        // description: device.description,
        viewOnly: true,
      },
      // panelClass: "location-radius-container",
      hasBackdrop: false,
    });
  }
}
